/** Imports nothing, so the usage, purchase and billing code can all share these words. */

/** What to tell someone whose billing isn't set up. There is no support address yet. */
export const CONTACT_SUPPORT_TO_SET_UP = 'Contact support to get it set up.';

/** Purchases are switched off: nobody can buy Dream Bucks, whatever their role. */
export const BUYING_UNAVAILABLE = 'Buying Dream Bucks isn’t available right now.';

/** A refusal for want of billing names a user other than the viewer: only they can set it up. */
export const ANOTHER_USER_NEEDS_TO_SET_UP =
	'Billing isn’t set up for another user whose usage is included here. They need to set it up on their own Billing page.';

/** What to say to someone whose billing isn't set up: the setup itself, an owner, or support. */
export type SetUpOffer = 'set-up' | 'ask-owner' | 'contact-support';

/**
 * "Billing isn’t set up for this organization yet. Contact support to get it set up." `subject`
 * names who the billing is for when the caller knows; `offer` is what comes after: nothing where
 * the page offers the setup itself, an owner for a member whose owners can, support otherwise.
 */
export function billingNotSetUpMessage(
	subject?: 'user' | 'organization',
	offer: SetUpOffer = 'contact-support',
): string {
	const sentence = `Billing isn’t set up${subject ? ` for this ${subject}` : ''} yet.`;
	switch (offer) {
		case 'set-up':
			return sentence;
		case 'ask-owner':
			return `${sentence} Ask an owner to get it set up.`;
		case 'contact-support':
			return `${sentence} ${CONTACT_SUPPORT_TO_SET_UP}`;
	}
}

/**
 * Wording for the refusals any billing call can answer with (billing off, not set up, provider
 * down), by the API's error `kind`; `undefined` for any other kind, which the caller words itself.
 */
export function sharedBillingErrorMessage(kind: string | undefined): string | undefined {
	switch (kind) {
		case 'BILLING_DISABLED':
			return 'Billing isn’t enabled on this server.';
		case 'BILLING_NOT_PROVISIONED':
			return billingNotSetUpMessage();
		case 'BILLING_PROVIDER_UNAVAILABLE':
			return 'Billing is temporarily unavailable. Try again in a moment.';
		default:
			return undefined;
	}
}
